import React from 'react';
import cn from 'classnames';

import { isSSRTheme } from 'utils';
import SSRLoader from './SSRLoader';

export default function Loader({ customClass = '' }) {
  if (isSSRTheme()) {
    return <SSRLoader />;
  }

  return (
    <div className={cn('spinner', customClass)}>
      <div className="double-bounce1" />
      <div className="double-bounce2" />
    </div>
  );
}
